/**
 * Vector Store - In-memory semantic search
 * Stores embeddings and performs cosine similarity search
 */

class VectorStore {
    constructor() {
        this.chunks = [];      // Array of { text, embedding }
        this.documentName = null;
    }

    /**
     * Clear the store
     */
    clear() {
        this.chunks = [];
        this.documentName = null;
    }

    /**
     * Add chunks with their embeddings
     * @param {Array} items - Array of { text, embedding }
     * @param {string} documentName - Name of the source document
     */
    addChunks(items, documentName = null) {
        this.chunks = items;
        this.documentName = documentName;
        console.log(`VectorStore: Added ${items.length} chunks from "${documentName}"`);
    }

    /**
     * Cosine similarity between two vectors
     */
    cosineSimilarity(a, b) {
        let dotProduct = 0;
        let normA = 0;
        let normB = 0;

        for (let i = 0; i < a.length; i++) {
            dotProduct += a[i] * b[i];
            normA += a[i] * a[i];
            normB += b[i] * b[i];
        }

        return dotProduct / (Math.sqrt(normA) * Math.sqrt(normB));
    }

    /**
     * Search for the most similar chunks
     * @param {Float32Array} queryEmbedding - The query embedding
     * @param {number} topK - Number of results to return
     * @returns {Array} - Array of { text, score }
     */
    search(queryEmbedding, topK = 5) {
        if (this.chunks.length === 0) {
            return [];
        }

        // Calculate similarities
        const results = this.chunks.map(chunk => ({
            text: chunk.text,
            score: this.cosineSimilarity(queryEmbedding, chunk.embedding)
        }));

        // Sort by score descending
        results.sort((a, b) => b.score - a.score);

        // Return top K
        return results.slice(0, topK);
    }

    /**
     * Check if store has documents
     */
    hasDocuments() {
        return this.chunks.length > 0;
    }

    /**
     * Get store info
     */
    getInfo() {
        return {
            documentName: this.documentName,
            chunkCount: this.chunks.length
        };
    }
}

export const vectorStore = new VectorStore();
export default vectorStore;
